export enum ACCEPT_TYPE {
  APPLICATION_DOC = 'application/msword',
  APPLICATION_DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  APPLICATION_DOTX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
  APPLICATION_DOCM = 'application/vnd.ms-word.document.macroEnabled.12',
  APPLICATION_DOTM = 'application/vnd.ms-word.template.macroEnabled.12',
  APPLICATION_XLS = 'application/vnd.ms-excel',
  APPLICATION_XLT = 'application/vnd.ms-excel',
  APPLICATION_XLA = 'application/vnd.ms-excel',
  APPLICATION_XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  APPLICATION_XLTX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
  APPLICATION_XLSM = 'application/vnd.ms-excel.sheet.macroEnabled.12',
  APPLICATION_XLTM = 'application/vnd.ms-excel.template.macroEnabled.12',
  APPLICATION_XLAM = 'application/vnd.ms-excel.addin.macroEnabled.12',
  APPLICATION_XLSB = 'application/vnd.ms-excel.sheet.binary.macroEnabled.12',
  APPLICATION_PPT = 'application/vnd.ms-powerpoint',
  APPLICATION_PPTX = 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  APPLICATION_POTX = 'application/vnd.openxmlformats-officedocument.presentationml.template',
  APPLICATION_PPSX = 'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
  APPLICATION_PPAM = 'application/vnd.ms-powerpoint.addin.macroEnabled.12',
  APPLICATION_PPTM = 'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
  APPLICATION_POTM = 'application/vnd.ms-powerpoint.template.macroEnabled.12',
  APPLICATION_PPSM = 'application/vnd.ms-powerpoint.slideshow.macroEnabled.12',
  APPLICATION_MDB = 'application/vnd.ms-access',
  APPLICATION_PDF = 'application/pdf',
  IMAGE_PNG = 'image/png',
  IMAGE_JPEG = 'image/jpeg',
  VIDEO_AVI = 'video/avi',
  VIDEO_3GP = 'video/3gp',
  VIDEO_MOV = 'video/mov',
  VIDEO_WMV = 'video/wmv',
  VIDEO_MPG = 'video/mpg',
  VIDEO_MPEG = 'video/mpeg',
  VIDEO_MP4 = 'video/mp4',
}
